// extracted by mini-css-extract-plugin
export default {"PortfolioPowerplantsTable":"PortfolioPowerplantsTable_PortfolioPowerplantsTable__ImuKy"};